"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by Tigran.Niksalyan on 09/23/2019.
 */
/**
 * Created by Tigran.Niksalyan on 09/23/2019.
 */
var WorkflowDesignerType;
/**
 * Created by Tigran.Niksalyan on 09/23/2019.
 */
(function (WorkflowDesignerType) {
    WorkflowDesignerType[WorkflowDesignerType["START"] = 0] = "START";
    WorkflowDesignerType[WorkflowDesignerType["ACTION_START"] = 1] = "ACTION_START";
    WorkflowDesignerType[WorkflowDesignerType["STATE"] = 2] = "STATE";
    WorkflowDesignerType[WorkflowDesignerType["ACTION"] = 3] = "ACTION";
    WorkflowDesignerType[WorkflowDesignerType["POINT"] = 4] = "POINT";
    WorkflowDesignerType[WorkflowDesignerType["GIZMO"] = 5] = "GIZMO";
    WorkflowDesignerType[WorkflowDesignerType["MINIVIEW"] = 6] = "MINIVIEW";
})(WorkflowDesignerType = exports.WorkflowDesignerType || (exports.WorkflowDesignerType = {}));
;
//# sourceMappingURL=workflow-designer.types.js.map